"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_typed_1 = require("@video/events-typed");
const adapter_1 = require("../../../api/adapter");
const feature_1 = require("../../../api/adapter/features/feature");
// reduce fft size since we're looking at time-domain
const FFT_SIZE = 64;
// analysis happens every second but look at the last 2
const HISTORY_SECONDS = 2;
// a lower tolerance provides less "stable" values
const TOLERANCE = 0.09;
const THRESHOLD_RATIO = 0.4;
// do we need it? if so it should be moved to constructor or so
// device.globals.set("printOutput", false);
const log = (...msg) => {
    const printOutput = adapter_1.device.globals.get("printOutput") === true;
    if (printOutput && adapter_1.device.isImplements(feature_1.Feature.DEBUGGING)) {
        adapter_1.device.console.log(...msg);
    }
};
class EchoDetector extends events_typed_1.EventEmitter {
    constructor(track) {
        super();
        this.total = 0;
        this.echo = false;
        this._history = [];
        this._currBucket = 0;
        if (!adapter_1.device.isImplements(feature_1.Feature.AUDIO_CONTEXT)) {
            throw new Error("Audio management is not supported");
        }
        this._audioContext = new adapter_1.device.AudioContext();
        this._analyserNode = this._audioContext.createAnalyser();
        this._processorNode = this._audioContext.createScriptProcessor();
        this._dataArray = new adapter_1.device.Uint8Array(this._analyserNode.fftSize);
        // reduce smoothing a bit
        this._analyserNode.smoothingTimeConstant = 0.4;
        this._analyserNode.fftSize = FFT_SIZE;
        this._processorNode.onaudioprocess = () => {
            var _a;
            this._analyserNode.getByteTimeDomainData(this._dataArray);
            const currTime = Date.now();
            const currBucket = Math.floor(currTime / 1000);
            if (this._currBucket !== currBucket) {
                if (this._history.length > HISTORY_SECONDS) {
                    this._history = this._history.slice(1, this._history.length);
                    this.runAnalysis();
                }
                this._history.push([]);
                this._currBucket = currBucket;
            }
            (_a = this._history[this._history.length - 1]) === null || _a === void 0 ? void 0 : _a.push(this.dataResult());
            this.total += 1;
        };
        if (!adapter_1.device.isImplements(feature_1.Feature.MEDIA_STREAM)) {
            throw new Error("media stream is not implemented");
        }
        this._mediaStream = new adapter_1.device.MediaStream();
        this._mediaStream.addTrack(track);
        this._mediaStreamSource = this._audioContext.createMediaStreamSource(this._mediaStream);
        this._mediaStreamSource.connect(this._analyserNode);
        this._analyserNode.connect(this._processorNode);
    }
    close() {
        this._audioContext.close();
    }
    dataResult() {
        let lowest = null;
        let highest = null;
        let sum = 0;
        for (let i = 0; i < this._dataArray.length; i += 1) {
            const value = this._dataArray[i];
            if (lowest == null || value < lowest) {
                lowest = value;
            }
            if (highest == null || value > highest) {
                highest = value;
            }
            sum += value;
        }
        return {
            lowest,
            highest,
            total: this._dataArray.length,
            sum,
            average: sum / this._dataArray.length,
        };
    }
    runAnalysis() {
        var _a, _b, _c;
        let increases = 0;
        let decreases = 0;
        let stables = 0;
        const chart = [];
        for (const [x, bin] of this._history.entries()) {
            for (const [y, value] of bin.entries()) {
                const prev = this._history[x - 1];
                if (prev != null) {
                    const previous = (_a = bin[y - 1]) !== null && _a !== void 0 ? _a : prev[prev.length - 1];
                    if (previous != null) {
                        const highest = (_b = value.highest) !== null && _b !== void 0 ? _b : 0;
                        const prevHighest = (_c = previous.highest) !== null && _c !== void 0 ? _c : 0;
                        const compareDecrease = prevHighest - Math.abs(prevHighest) * TOLERANCE;
                        if (highest >= compareDecrease) {
                            const compareIncrease = prevHighest + Math.abs(prevHighest) * TOLERANCE;
                            if (highest <= compareIncrease) {
                                stables += 1;
                                chart.push("s");
                            }
                            else {
                                increases += 1;
                                chart.push("i");
                            }
                        }
                        else {
                            decreases += 1;
                            chart.push("d");
                        }
                    }
                }
            }
        }
        const variations = increases + decreases;
        const total = variations + stables;
        if (variations / total > THRESHOLD_RATIO) {
            if (!this.echo) {
                this.echo = true;
                this.emit("echo");
            }
        }
        else if (this.echo) {
            this.echo = false;
            this.emit("noecho");
        }
        log(`${chart.join("")} - (${increases}/${decreases}/${stables}) (${variations})/${total})`);
    }
}
EchoDetector.displayName = "EchoDetector";
exports.default = EchoDetector;
//# sourceMappingURL=echo.js.map